import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import CustomerFilterDialog from "./CustomerFiltersDialog";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function CustomerFilters({ callTableViewModel, setCallTableViewModel }: IFiltersProps) {
    const [open, setOpen] = useState(false);

    const text = <Typography variant="body1">
        {
            "Customer "
        }
        {
            callTableViewModel.filters.customerFilters.customerID ? " - " + callTableViewModel.filters.customerFilters.customerID : ''
        }
        {
            callTableViewModel.filters.customerFilters.clientRef ? " - " + callTableViewModel.filters.customerFilters.clientRef : ''
        }
        {
            callTableViewModel.filters.customerFilters.telephone ? " - " + callTableViewModel.filters.customerFilters.telephone : ''
        }
        {
            callTableViewModel.filters.customerFilters.urn ? " - " + callTableViewModel.filters.customerFilters.urn : ''
        }
    </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <CustomerFilterDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}